import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography, useTheme } from "@mui/material";
import { NavLink } from "react-router-dom";
import { MyMealsMenu } from "../MyMealsMenu/MainComponents/MyMealsMenu";
import { NavDrawerMenuItem } from "../NavDrawerMenuItem";
import { AccountRoutesType } from "../navigationUtils";
const isActive = (location, nav) => location.pathname === nav.to && nav.to !== AccountRoutesType.LOGOUT;
export const NavDrawerLinks = ({ links }) => {
    const theme = useTheme();
    const selectedColor = theme.palette.common.black;
    const unSelectedColor = theme.palette.grey[`A700`];
    return (_jsx(_Fragment, { children: links.map((nav) => {
            if (nav.to === AccountRoutesType.MY_MEALS) {
                return _jsx(MyMealsMenu, { displayText: nav.displayText, isNavDrawer: true }, nav.to);
            }
            else {
                return (_jsx(NavDrawerMenuItem, Object.assign({ component: NavLink, to: nav.to, selected: isActive(location, nav), className: nav.to === AccountRoutesType.LOGOUT ? "is-logout" : "" }, { children: _jsx(Typography, Object.assign({ variant: "h4", color: isActive(location, nav) ? selectedColor : unSelectedColor }, { children: nav.displayText })) }), nav.to));
            }
        }) }));
};
